import { render, staticRenderFns } from "./subledgerVendor.vue?vue&type=template&id=c0ffc3d0&scoped=true&"
import script from "./subledgerVendor.vue?vue&type=script&lang=js&"
export * from "./subledgerVendor.vue?vue&type=script&lang=js&"
import style0 from "./subledgerVendor.vue?vue&type=style&index=0&id=c0ffc3d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ffc3d0",
  null
  
)

export default component.exports